import { useTranslation } from 'react-i18next'
import AccountView from '~/pages/account/AccountView'
import AccommodationCard from '~/pages/account/components/accommodation/AccommodationCard'
import LearnerFrame from '~/pages/scorm/components/LearnerFrame'

/** « Mon compte » dans le cadre de l'espace apprenant (#77). */
function LearnerAccountPage() {
  const { t } = useTranslation()

  return (
    <LearnerFrame label={t('account.title')}>
      <h1 className="mb-6 font-heading text-2xl font-bold tracking-tight sm:text-3xl">{t('account.title')}</h1>
      {/* Réservé à l'apprenant (`route-access.ts`) : la demande d'aménagement (#327) est la sienne. */}
      <AccountView extra={<AccommodationCard />} />
    </LearnerFrame>
  )
}

export default LearnerAccountPage
